import { gql } from '@moonpig/web-core-graphql'

export const ModuleHeadingFragment = gql`
  fragment ModuleHeading on ModuleHeading {
    __typename
    heading
    hidden
  }
`
